import { TransactionData } from '.'
import Loader from '../Loader'
import { ButtonBox, PageSubtitle, PageTitle } from './styles'
import { DASHCOLORS, DashboardhMediumButton } from 'bd-web-components'

type AdavanceCoreProps = {
  modalData: TransactionData
  isMutating: boolean
  onSubmit: (e: any) => any
}

export const AdvanceCore = ({
  modalData,
  isMutating,
  onSubmit,
}: AdavanceCoreProps) => {
  return (
    <>
      {modalData.type === 'advance' && (
        <>
          <PageTitle>{modalData.title}</PageTitle>
          <PageSubtitle>{modalData.description}</PageSubtitle>
          <PageTitle>{modalData.value}</PageTitle>
          <ButtonBox>
            <DashboardhMediumButton
              color="#fff"
              background={DASHCOLORS.SECONDARY_BLUE_01}
              height="48px"
              maxWidth="100%"
              variant="contained"
              disabled={isMutating}
              onClick={onSubmit as any}
              width="250px"
            >
              {!isMutating ? (
                <span className="button__submit_code">
                  {'Extrato Antecipação'}
                </span>
              ) : (
                <Loader small={true} />
              )}
            </DashboardhMediumButton>
          </ButtonBox>
        </>
      )}
    </>
  )
}
